var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1021.67 466.34c-13.33-186.69-140.74-357.56-313.48-428-85-36.79-180-43.86-271.23-33.6C184.35 38.29-14.78 274.64.86 529.94c3 281 258.12 512.68 537.87 492.39 286.74-9.65 510.7-271.63 482.94-555.99zM511.3 953.93C-76.57 941.74-66.23 69 520.74 69.42c572.53 18.58 569.04 875.96-9.44 884.51zM811.5 806.5h-281v-85h193v-87h-193v-227h196v-67.24h-196v-85h281V492.5h-196v57h196zm-604 0h281v-85h-193v-87h193v-227h-196v-67.24h196v-85h-281V492.5h196v57h-196z",
    fill: "#c2282b"
  })));
}
export default SvgGs;